var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVestel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 119,
    height: 27,
    viewBox: "0 0 119 27",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8165 0.853516V26.4053H42.7028V22.8692H33.0454V15.3975H41.0933V12.3808H33.0454V3.87019H42.1596V0.853516H24.8165Z",
    fill: "#7B7B95"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5898 0.853516V4.1299H66.8795V26.4053H75.0004V4.1299H81.0313V0.853516H60.5898Z",
    fill: "#7B7B95"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7338 0.853516V26.4053H99.7683V22.8692H90.6962V15.3975H98.4834V12.3808H90.6962V3.87019H99.2622V0.853516H82.7338Z",
    fill: "#7B7B95"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M100.622 0.853516V26.4053H118.508V22.8692H109.165V0.853516H100.622Z",
    fill: "#7B7B95"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6577 0.853516L14.2733 18.6799L8.71255 0.853516H0.116943L8.92793 26.4053H15.3697L23.9653 0.853516H19.6577Z",
    fill: "#7B7B95"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3481 0.853516H52.4347C52.4347 0.853516 44.2263 1.14857 43.5888 8.68231C42.9512 16.2357 51.4784 16.0587 53.0523 19.2846C54.0684 21.35 51.578 22.9237 49.4861 22.9237H43.788V26.4053H53.4508C53.4508 26.4053 63.5718 25.8742 62.1573 17.2783C61.2408 11.7509 55.0447 12.5967 52.9726 8.87902C50.9006 5.16132 54.5067 4.09912 54.9052 4.09912H59.3082L59.3481 0.853516Z",
    fill: "#7B7B95"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVestel);
export default __webpack_public_path__ + "static/media/vestel.2819dd6fbed193ada85bb4ac5fab1752.svg";
export { ForwardRef as ReactComponent };